import React from 'react';
import PropTypes from 'prop-types';
import styles from './SelectionSummary.module.scss';

const SelectionSummary = ({selectedCount, showSelectionSummary}) => {
  let summaryText = null;

  if (showSelectionSummary) {
    summaryText = `${selectedCount} item (s) selected`;
  } else if (selectedCount > 0) {
    summaryText = `${selectedCount} item(s) selected`;
  }

  return <div className={styles.selectionSummary}>{summaryText}</div>;
};

SelectionSummary.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  showSelectionSummary: PropTypes.bool
};

export default SelectionSummary;
